import { useEffect, useState } from "react";
import { Button, Checkbox, Popover } from "antd";
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import LoansClosingCosts from "./LoansClosingCosts";
import './closingCosts.less'
import { useReportCSUpdate } from "../../../../hooks/reports";
import { useContextReports } from "../../../../context/reports";
import { EnumReportTypes } from '../../../../types/reports';
import { formatAmount } from '../../../../utils/formatAmount';
import { calculateClosingCosts } from '../../../../utils/calculateClosingCosts';
import { calculateLoanAmountWithUip } from '../../../../utils/calculateLoanAmountWithUip';
import { calculateDownPaymentPrice } from '../../../../utils/calculateDownPaymentPrice';
import { calculatePrincipalInterest } from '../../../../utils/calculatePrincipalInterest';

const DETAILS_AVAILABLE_DEFAULT = false

const ClosingCostsDetails = () => {
	const form = useFormInstance();
	const [detailsAvailable, setDetailsAvailable] = useState<boolean>(DETAILS_AVAILABLE_DEFAULT);
	const [closingCostsOpen, setClosingCostsOpen] = useState<boolean>(false);
	const {
		reportId,
		report,
		getReport,
		closingCostsLoading,
		handleLoansUpdate,
    isBorrower,
    reportClosingCosts,
    reportLoanClosingCosts
	} = useContextReports();
	const { fetch: updateReport, loading } = useReportCSUpdate();

	useEffect(() => {
		if (report && report.csActive !== undefined) {
			setDetailsAvailable(report.csActive);
		}
	}, [report]);

	const handleUpdateDetailsAvailable = async (available: boolean) => {
		await updateReport({ csActive: available }, reportId)
			.then(() => {
				setDetailsAvailable(available);
				getReport?.();
			})

		if (!available) {
			// Recalculate closing costs
			const loans = form.getFieldValue('loans') || [];
      const isRefinance = report?.reportType === EnumReportTypes.refinance;

			loans.forEach((loan: any, i: number) => {
        const totalClosingCosts = calculateClosingCosts(form, i, reportLoanClosingCosts, reportClosingCosts)

        const isFirstItemInRefinance = isRefinance && i === 0;

				if (!isFirstItemInRefinance) {
          form.setFieldValue(['loans', i, 'closingCosts', 'value'], totalClosingCosts);
        }

        const loanAmountWithUip = calculateLoanAmountWithUip(form, i, { closingCosts: totalClosingCosts  })

        form.setFieldValue(['loans', i, 'loanAmountWithUip', 'value'], loanAmountWithUip);

        const downPaymentPrice = calculateDownPaymentPrice(form, i)

        form.setFieldValue(['loans', i, 'down_payment_price'], downPaymentPrice)

        const updatedLoan = form.getFieldValue(['loans', i]);

        const principalInterest = calculatePrincipalInterest(updatedLoan);

        form.setFieldValue(['loans', i, 'principalInterest', 'value'], principalInterest);
			});
		}

		handleLoansUpdate?.();
	}

	return (
		<div className="cost-options">
			<LoansClosingCosts open={closingCostsOpen} onCancel={() => setClosingCostsOpen(false)} />
      {!(isBorrower && detailsAvailable) && (
        <Button
          type="default"
          onClick={() => setClosingCostsOpen(true)}
          disabled={detailsAvailable}
          loading={closingCostsLoading}
        >
          Details
        </Button>
      )}
      {!isBorrower && (
        <Popover content="Custom amount.">
          <Checkbox
            onChange={(e) => handleUpdateDetailsAvailable(e.target.checked)}
            checked={detailsAvailable}
            disabled={loading}
          />
        </Popover>
      )}
		</div>
	)
}

export default ClosingCostsDetails;
